import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const ACCESS = "th_access";
const REFRESH = "th_refresh";

export const tokenStore = {
  get access() {
    return localStorage.getItem(ACCESS);
  },
  get refresh() {
    return localStorage.getItem(REFRESH);
  },
  set(access, refresh) {
    if (access) localStorage.setItem(ACCESS, access);
    if (refresh) localStorage.setItem(REFRESH, refresh);
  },
  clear() {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
  },
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStore.access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && config && !config._retry) {
      const rt = tokenStore.refresh;
      if (!rt) {
        tokenStore.clear();
        throw error;
      }
      config._retry = true;
      try {
        refreshing =
          refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: rt });
        const { data } = await refreshing;
        refreshing = null;
        tokenStore.set(data.access_token, data.refresh_token);
        config.headers.Authorization = `Bearer ${data.access_token}`;
        return api(config);
      } catch (e) {
        refreshing = null;
        tokenStore.clear();
        window.dispatchEvent(new Event("th-logout"));
        throw e;
      }
    }
    throw error;
  }
);

export default api;
